import { Injectable } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import { Endereco } from './endereco';
import { environment } from '../../../environments/environment';
import { Pais } from './pais';
import { Estado } from './estado';
import { Cidade } from './cidade';

@Injectable()
export class EnderecoService {

  constructor(private http: Http, private router: Router) { }

  consultaCEP(cep: string): Observable<Endereco> {
    cep = cep.replace(/\D/g, '');
    if (cep != '') {
      const validacep = /^[0-9]{8}$/;
      if (validacep.test(cep)) {
        return this.http.get(environment.apiGxUrl + '/dpendereco.svc/rest/?cepnro=' + cep)
          .map(dados => dados.json())
          .catch((err: any) => {
            return Observable.throw(err.json());
          });
      }
    }
  }

  getPaises() {
    return this.http.get(environment.apiUrl + '/paises')
      .map(res => {
        return res.json().map(pais => Pais.fromJson(pais));
      })
      .catch((err: any) => {
        return Observable.throw(err.json());
      });
  }

  getEstados(pais_id) {
    return this.http.get(environment.apiUrl + '/estados/' + pais_id)
      .map(res => {
        return res.json().map(estado => Estado.fromJson(estado));
      })
      .catch((err: any) => {
        return Observable.throw(err.json());
      });
  }

  getCidades(estado_id) {
    return this.http.get(environment.apiUrl + '/cidades/' + estado_id)
      .map(res => {
        return res.json().map(cidade => Cidade.fromJson(cidade));
      })
      .catch((err: any) => {
        return Observable.throw(err.json());
      });
  }

  //Chamado 560376 - Rafael dos Santos - 16/08/2024
  getPrcTipPrc(){
    let endereco = "";
    let regex = /[A-Z]{1,2}(?=-\d{4}-\d{1}-InscricaoMatricula$)/;
    let match;
    let PrcTipPrc = "";

    endereco = this.router.url;
    match = endereco.match(regex);

    if (match){
      PrcTipPrc = match[0];
    }else{
      PrcTipPrc = "";
    }

    return PrcTipPrc;

  }

  //Chamado 567706 - Rafael dos Santos - 19/09/2024
  getPrcLetAnoUrl(){

    let endereco = "";
    let regex = /(\d){4}(?=-\d{1}-InscricaoMatricula$)/;
    let match;
    let PrcLetAno = "";

    endereco = this.router.url;
    match = endereco.match(regex);

    if (match){
      PrcLetAno = match[0];
    }else{
      PrcLetAno = "";
    }

    return PrcLetAno;

  }

  //Chamado 567706 - Rafael dos Santos - 19/09/2024
  getPrcLetSemUrl(){

    let endereco = "";
    let regex = /(\d){1}(?=-InscricaoMatricula$)/;
    let match;
    let PrcLetSem = "";

    endereco = this.router.url;
    match = endereco.match(regex);

    if (match){
      PrcLetSem = match[0];
    }else{
      PrcLetSem = "";
    }

    return PrcLetSem;

  }

  getPrcTipCodUrl(){

    let endereco = "";
    let regex = /\d*(?=\-\d{1}\-\w{1,2}\-\d{4}\-\d{1}\-InscricaoMatricula$)/;
    let match;
    let PrcTipCod = "";

    endereco = this.router.url;
    match = endereco.match(regex);

    if (match){
      PrcTipCod = match[0];
    }else{
      PrcTipCod = "";
    }

    return PrcTipCod;

  }

  getPrcOcoSeqUrl(){

    let endereco = "";
    let regex = /\d*(?=\-\w{1,2}\-\d{4}\-\d{1}\-InscricaoMatricula$)/;
    let match;
    let PrcOcoSeq = "";

    endereco = this.router.url;
    match = endereco.match(regex);

    if (match){
      PrcOcoSeq = match[0];
    }else{
      PrcOcoSeq = "";
    }

    return PrcOcoSeq;

  }
}



// WEBPACK FOOTER //
// ./src/app/_shared/endereco/endereco.service.ts